import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const SessionDateDisplay = ({
  startTime,
  endTime,
  showDuration = true
}) => /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: showDuration ? 'academyComponents.liveEventOverviewModal.sessionTime' : 'academyComponents.liveEventOverviewModal.sessionTimeWithoutDuration',
  options: {
    date: /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "short-date",
      type: "userTz",
      value: startTime
    }),
    startTime: /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "LT",
      type: "userTz",
      value: startTime
    }),
    endTime: /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "LT",
      type: "userTz",
      value: endTime
    }),
    // eslint-disable-next-line react-hooks/purity
    duration: /*#__PURE__*/_jsx(FormattedDuration, {
      from: Date.now() - (endTime - startTime)
    })
  }
});
export default SessionDateDisplay;